/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { EmployeeAttribute } from './EmployeeAttribute';
import {
    EmployeeAttributeFromJSON,
    EmployeeAttributeFromJSONTyped,
    EmployeeAttributeToJSON,
    EmployeeAttributeToJSONTyped,
} from './EmployeeAttribute';

/**
 * 
 * @export
 * @interface ListEmployeeAttributesResponse
 */
export interface ListEmployeeAttributesResponse {
    /**
     * 
     * @type {Array<EmployeeAttribute>}
     * @memberof ListEmployeeAttributesResponse
     */
    data: Array<EmployeeAttribute>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEmployeeAttributesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListEmployeeAttributesResponse interface.
 */
export function instanceOfListEmployeeAttributesResponse(value: object): value is ListEmployeeAttributesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEmployeeAttributesResponseFromJSON(json: any): ListEmployeeAttributesResponse {
    return ListEmployeeAttributesResponseFromJSONTyped(json, false);
}

export function ListEmployeeAttributesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmployeeAttributesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeeAttributeFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEmployeeAttributesResponseToJSON(json: any): ListEmployeeAttributesResponse {
      return ListEmployeeAttributesResponseToJSONTyped(json, false);
  }

  export function ListEmployeeAttributesResponseToJSONTyped(value?: ListEmployeeAttributesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeeAttributeToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

